import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import {
  AngleLeftLightIcon,
  AngleRightLightIcon
} from '../../shared/icons/icons';

import { ChildrenProp } from '../../shared/utils/prop-types/prop-types';

import './date-toggle.scss';

function DateToggle(props) {
  const {
    children,
    className,
    dates,
    defaultDate = format(new Date(), 'MM/DD/YYYY'),
    onSelectDate,
    selectedDate
  } = props;

  if (!Array.isArray(dates)) {
    return null;
  }

  const myDate = selectedDate || defaultDate;
  const currentIndex = getCurrentDateIndex(myDate);
  const dayOfWeek = format(myDate || '', 'dddd');
  const formattedDate = format(myDate || '', 'MMMM Do');
  const showPrev = currentIndex > 0;
  const showNext = currentIndex < dates.length - 1;

  function getCurrentDateIndex(selectedDate) {
    return dates.findIndex(date => date === selectedDate);
  }

  return (
    <div className={className} styleName="container">
      <button
        aria-label="Previous Date"
        data-testid={'prevButton'}
        disabled={!showPrev}
        onClick={() => onSelectDate(dates[currentIndex - 1])}
        styleName={showPrev ? 'toggle' : 'invisible'}
        type="button"
      >
        <AngleLeftLightIcon />
      </button>

      <span styleName="current-date">
        <strong>
          {dayOfWeek}, {formattedDate}
        </strong>
      </span>

      <button
        aria-label="Next Date"
        data-testid={'nextButton'}
        disabled={!showNext}
        onClick={() => onSelectDate(dates[currentIndex + 1])}
        styleName={showNext ? 'toggle' : 'invisible'}
        type="button"
      >
        <AngleRightLightIcon />
      </button>

      {children}
    </div>
  );
}

DateToggle.propTypes = {
  children: ChildrenProp,
  className: PropTypes.string,
  dates: PropTypes.array.isRequired,
  defaultDate: PropTypes.string,
  onSelectDate: PropTypes.func,
  selectedDate: PropTypes.string
};

export default DateToggle;
